export default __webpack_public_path__ + "static/media/portis.9a1a56e5.svg";